import { fetchFromOldApi } from '~/services/Http';

export type EmplHistoryDetailType = {
  fEmplId: string;
  fEmplDetailStartDate: string;
  fEmplDetailEndDate: string;
  fEmplDetailInfo: number;
  fEmplDetailStatus: string;
  fEmplDetailJobGrade: string;
  fEmplDetailTaxNumber?: string;
  fEmplDetailPersonnelGroup1?: string;
  fEmplDetailPersonnelGroup2?: string;
  fEmplDetailPersonnelGroup3?: string;
  fEmplDetailPersonnelGroup4?: string;
  fEmplDetailPersonnelGroup5?: string;
  fEmplDetailVacBalCalcSixDays: number;
  fEmplDetailCalcHoursBalance: boolean;
  fEmplDetailIsPending: boolean;
  fEmplSubEnteredTime: string;
  fEmplSubSupersededTime: string;
};

export const getEmplDetailHistory = (
  iEmpId: string,
  iEmplEmpId: number,
): Promise<EmplHistoryDetailType[]> => {
  return fetchFromOldApi(
    '/json/employee/' +
      iEmpId +
      '/employment/' +
      iEmplEmpId +
      '/details?period=historical',
  ).then((r) => r.json());
};
